"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorGroupSchema = exports.electionCalculatorGroupSchema = exports.electionCalculatorItemSchema = exports.standaloneCalculatorInGroupSchema = exports.calculatorItemSchema = exports.calculatorGroupBaseSchema = exports.calculatorGroupSchemaReference = void 0;
const zod_1 = require("zod");
const calculator_schema_1 = require("./calculator.schema");
const electionSchema = __importStar(require("./election.schema"));
const variant_schema_1 = require("./variant.schema");
const calculatorGroupIdSchema = zod_1.z.string().uuid().describe("Unique identifier of a calculator group in the format of UUID");
const calculatorKeySchema = zod_1.z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Key of the calculator; forms the last URL segment");
const selectionSchema = zod_1.z
    .object({
    title: zod_1.z.string().describe("Heading of the calculator picker; overrides the app default").optional(),
    description: zod_1.z.string().describe("Description shown in the calculator picker").optional(),
    searchPlaceholder: zod_1.z.string().describe("Placeholder of the calculator picker search field").optional(),
    showCode: zod_1.z.boolean().describe("Whether to display district codes next to district names; overrides the app default").optional(),
})
    .strict()
    .describe("Optional copy and display overrides for the calculator picker");
const calculatorGroupKeySchema = zod_1.z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Human-friendly unique key of a calculator group in the hyphen-separated lowercased format");
exports.calculatorGroupSchemaReference = zod_1.z
    .object({
    id: calculatorGroupIdSchema,
    key: calculatorGroupKeySchema,
})
    .strict();
exports.calculatorGroupBaseSchema = zod_1.z
    .object({
    id: calculatorGroupIdSchema,
    key: calculatorGroupKeySchema,
    createdAt: zod_1.z.string().datetime({ offset: true }).describe("Time of the creation of a calculator group in the ISO 8601 format"),
    updatedAt: zod_1.z.string().datetime({ offset: true }).describe("Time of the last update of a calculator group in the ISO 8601 format").optional(),
    publishedAt: zod_1.z.string().datetime({ offset: true }).describe("Time when a calculator group should be published in the ISO 8601 format").optional(),
    title: zod_1.z.string().describe("Title of a calculator group").optional(),
    shortTitle: zod_1.z.string().max(25).describe("Short title of a calculator group with a maximum of 25 characters").optional(),
    description: zod_1.z.string().describe("Description of a calculator group").optional(),
    election: zod_1.z.lazy(() => electionSchema.electionSchemaReference).optional(),
    variants: zod_1.z.array(variant_schema_1.variantSchema).min(1).describe("Ordered list of calculator variants").optional(),
    selection: selectionSchema.optional(),
})
    .strict();
exports.calculatorItemSchema = zod_1.z.lazy(() => calculator_schema_1.calculatorBaseSchema
    .pick({ id: true })
    .extend({
    key: calculatorKeySchema,
    variant: calculator_schema_1.calculatorVariantSchema,
})
    .strict());
exports.standaloneCalculatorInGroupSchema = exports.calculatorGroupBaseSchema
    .extend({
    shortTitle: zod_1.z.string().max(25).describe("Short title of a calculator group with a maximum of 25 characters"),
    calculators: zod_1.z.array(exports.calculatorItemSchema).min(1).describe("Ordered list of calculators"),
    election: zod_1.z.undefined().optional(),
})
    .strict();
exports.electionCalculatorItemSchema = zod_1.z.lazy(() => calculator_schema_1.calculatorBaseSchema
    .pick({ id: true })
    .extend({
    key: calculatorKeySchema,
    variant: calculator_schema_1.calculatorVariantSchema.optional(),
    district: calculator_schema_1.calculatorDistrictSchema.optional(),
    round: calculator_schema_1.calculatorRoundSchema.optional(),
})
    .strict()
    .refine((data) => data.variant || data.district || data.round, {
    message: "Calculator must have at least a variant, district, or round.",
}));
exports.electionCalculatorGroupSchema = exports.calculatorGroupBaseSchema
    .extend({
    election: zod_1.z.lazy(() => electionSchema.electionSchemaReference),
    calculators: zod_1.z.array(exports.electionCalculatorItemSchema).min(1).describe("Ordered list of calculators from an election"),
    shortTitle: zod_1.z.undefined().optional(),
})
    .strict();
exports.calculatorGroupSchema = zod_1.z.union([exports.standaloneCalculatorInGroupSchema, exports.electionCalculatorGroupSchema]);
